import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'dateToTimeRemaining'
})
export class DateToTimeRemainingPipe implements PipeTransform {

  transform(value: Date, hideAffix: boolean = true): string {
    return moment(value).fromNow(hideAffix);
  }

}
